// extracted by mini-css-extract-plugin
export var bubble = "_2o-0";
export var container = "_2o-f";
export var contrastBorder = "_2o-g";
export var greyOut = "_2o-2";
export var initialsColor0 = "_2o-3";
export var initialsColor1 = "_2o-4";
export var initialsColor10 = "_2o-d";
export var initialsColor11 = "_2o-e";
export var initialsColor2 = "_2o-5";
export var initialsColor3 = "_2o-6";
export var initialsColor4 = "_2o-7";
export var initialsColor5 = "_2o-8";
export var initialsColor6 = "_2o-9";
export var initialsColor7 = "_2o-a";
export var initialsColor8 = "_2o-b";
export var initialsColor9 = "_2o-c";
export var initialsWrapper = "_2o-1";
export var large = "_2o-l";
export var medium = "_2o-k";
export var mediumSmall = "_2o-j";
export var mediumSmallMedium = "_2o-o";
export var micro = "_2o-h";
export var small = "_2o-i";
export var tiny = "_2o-n";
export var xTiny = "_2o-m";